import { Box, Checkbox, Divider, Typography } from '@mui/material'

import { color } from 'config/color'
import { FormLabel, SvgImage } from 'components'
import { useMobileBreakpoints } from 'utils'

interface IUnlinkedAccountCard {
  accountId: string
  serviceAddress: string
  selectedAccounts: any
  setSelectedAccounts: any
}

export const UnlinkedAccountCard = ({
  accountId,
  serviceAddress,
  selectedAccounts,
  setSelectedAccounts
}: IUnlinkedAccountCard): JSX.Element => {
  const isMobile = useMobileBreakpoints()
  const isSelected = selectedAccounts?.includes(accountId)

  const handleAddSelected = (event: { target: { checked: boolean } }): void => {
    if (event.target.checked) {
      setSelectedAccounts([...selectedAccounts, accountId])
    } else {
      setSelectedAccounts(
        selectedAccounts.filter(
          (selectedAccountId: string) => selectedAccountId !== accountId
        )
      )
    }
  }

  return (
    <Box border={`1px solid ${color.secondary.dark[300]}`}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        p={1}
        bgcolor={color.grey[100]}
        gap={isMobile ? 1 : 0}
      >
        <Box display="flex" flexDirection="row" alignItems="center">
          <FormLabel marginBottom={0}>Account ID: </FormLabel>
          <Typography color={color.grey[600]} fontWeight={400} fontSize={15}>
            {accountId}
          </Typography>
        </Box>

        <Checkbox
          name="selected"
          icon={<SvgImage name="CheckboxOutline" width={20} height={20} />}
          checkedIcon={
            <SvgImage name="CheckboxIconBlue" width={20} height={20} />
          }
          checked={isSelected}
          onChange={handleAddSelected}
        />
      </Box>

      <Divider sx={{ color: color.secondary.dark[300] }} />

      <Box
        display="flex"
        justifyContent="space-between"
        flexDirection={isMobile ? 'column' : 'row'}
        px={2}
        py={3}
        bgcolor={color.white}
        gap={isMobile ? 1 : 0}
      >
        <Box>
          <FormLabel>Service Address: </FormLabel>
          <Typography color={color.grey[900]} fontWeight={400} fontSize={15}>
            {serviceAddress}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
